export default {
  projectDesc: 'A <strong>Vue2</strong> plugin to make video play easier',
  demo: {},
  option: {
    url: 'video source url',
    loop: 'causes the video to start over as soon as it ends',
    auto: 'begins playback when the player is ready<br><code>play</code> autoplay with sound<br><code>muted</code> autoplay with muted',
    poster: 'A URL to an image that displays before the video begins playing. This is often a frame of the video or a custom title screen. As soon as the user hits "play" the image will go away'
  },
  event: {
    play: 'video start play',
    pause: 'play pause',
    end: 'video playback completed. it will call <code>pause</code> event before <code>end</code>'
  }
}
